import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Application from "./components/Application";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { darkTheme } from "./styles/globalStyles";

ReactDOM.render(
	<React.StrictMode>
		<ThemeProvider theme={darkTheme}>
			<Router>
				<Application />
			</Router>
		</ThemeProvider>
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
